import { createContext, useContext, useEffect, useState } from "react";
import { http, saveAuth, clearAuth, currentUser } from "@/lib/api";

const AuthCtx = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(currentUser());
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const t = localStorage.getItem("gv_token");
    if (!t) { setLoading(false); return; }
    http.get("/api/auth/me")
      .then((res) => { setUser(res.data.user); localStorage.setItem("gv_user", JSON.stringify(res.data.user)); })
      .catch(() => { clearAuth(); setUser(null); })
      .finally(() => setLoading(false));
  }, []);

  const login = (token, u) => { saveAuth(token, u); setUser(u); };
  const logout = () => { clearAuth(); setUser(null); };

  return <AuthCtx.Provider value={{ user, loading, login, logout }}>{children}</AuthCtx.Provider>;
}

export const useAuth = () => useContext(AuthCtx);
